import { render, staticRenderFns } from "./vd-order-hold.vue?vue&type=template&id=f0019ce6&scoped=true"
import script from "./vd-order-hold.vue?vue&type=script&lang=js"
export * from "./vd-order-hold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0019ce6",
  null
  
)

export default component.exports